import type { ToolAccessMode } from "@amoreg/contracts";
import { LockIcon, LockOpenIcon } from "lucide-react";

export type ComposerAccessMode = ToolAccessMode;

// Adapted from T3's runtime-mode picker; only expose modes Eve supports.
export const composerAccessOptions = {
  "approval-required": {
    label: "Supervised",
    description: "Ask before gated app, governance, and sandbox actions.",
    icon: LockIcon,
  },
  "full-access": {
    label: "Full access",
    description: "Allow app, governance, and sandbox commands for new messages in this tab.",
    icon: LockOpenIcon,
  },
} as const;

export function isComposerAccessMode(value: unknown): value is ComposerAccessMode {
  return typeof value === "string" && Object.hasOwn(composerAccessOptions, value);
}
